import moment from 'moment';

export const isDateBetweenMonthRange = (date: any, startMonth: number, endMonth: number): boolean => {
  const month = moment(date).month() + 1;
  return endMonth < startMonth
    ? (month >= (startMonth) && month <= 12) || month === (endMonth)
    : month >= (startMonth) && month <= (endMonth);
};
